import { useAuth } from "hooks/useAuth";

// Компонент-обгортка для перевірки дозволів з опціональним fallback-елементом
const PermissionWrapper = ({ requiredPermission, children, fallback = null }) => {
  const { isAllowed } = useAuth();

  // Якщо дозвіл не вимагається, просто показуємо дочірній елемент
  if (!requiredPermission) {
    return <>{children}</>;
  }

  // Якщо користувач має дозвіл, рендеримо дочірні елементи.
  // В іншому випадку, рендеримо fallback-елемент (який по дефолту null).
  return isAllowed(requiredPermission) ? <>{children}</> : fallback;
};

export default PermissionWrapper;
